<script setup lang="ts">
import { FhText } from '@fareharbor-com/beacon-vue';
import BaseFlexbox from '@/components/ui/BaseFlexbox/BaseFlexbox.vue';
import type { ItemListTableInstance } from './types';

interface ItemListQualityScoreProps {
  row: ItemListTableInstance;
}

defineProps<ItemListQualityScoreProps>();
</script>

<template>
  <BaseFlexbox class="px-1 py-2" direction="row">
    <FhText tag="span">{{ row.qualityScore }}</FhText>
  </BaseFlexbox>
</template>
